import i18next from 'i18next';
import numeral from 'numeral';
import { cache } from './cache';
var moment = require('moment-timezone');
var TIMEZONE_GREENDOT = 'America/Port_of_Spain';
var TIMEZONE_UTC = 'UTC';

export function formatDateToDDMMYYYYFrEpoch(epochTime, normal) {
    var d = new Date(epochTime * 1000); // The 0 there is the key, which sets the date to the epoch
    return normal ? formatDateToDDMMYYYY(d) : formatDateToShortMonthName(d); //formatDateToMonthNameAndDayOfWeek(d)
}

export function formatDateTimeFrEpoch(epochTime, isOrg, disableSecond) {
    var d = new Date(epochTime * 1000); // The 0 there is the key, which sets the date to the epoch
    if (isOrg) return d;
    return formatDateTime(epochTime, disableSecond);
}

export function epochToDatetimeStrWithTz(epochDate, withTime, utc) {
    try {
        if (epochDate) {
            // var crmDate = moment.tz(epochDate * 1000, CRM_TZ);
            // if(withTime)
            //     return crmDate.format('DD/MM/YYYY HH:MM:SS');
            // else 
            //     return crmDate.format('DD/MM/YYYY');

            const dateObject = new Date(epochDate * 1000);
            let options = {
                timeZone: utc ? TIMEZONE_UTC : TIMEZONE_GREENDOT,
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            };
            
            if(withTime){
                options = {
                    timeZone: utc ? TIMEZONE_UTC : TIMEZONE_GREENDOT,
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit',
                    hour12: false
                };
            }
            
            const dateTimeString = dateObject.toLocaleString('de-DE', options).replace(/\./g, "/").replace(/\,/g, "");
            return dateTimeString;
        } 
        
        return null;
    } catch (ex) {
        console.log("epochToCRMDatetime exception:", ex);
        return null;
    }
}

export function epochToCRMDatetimeStrTz(epochDate, withTime, utc) {
    try {
        if (epochDate) {
            var crmDate = moment.tz(epochDate * 1000, TIMEZONE_UTC);
            if(withTime)
                return crmDate.format('YYYY-MM-DD HH:MM:SS');
            else 
                return crmDate.format('YYYY-MM-DD');    
        }         
    } catch (ex) {
        console.log("epochToCRMDatetime exception:", ex);
    }

    return null;
}
    
export function formatDateTime(epochTime, disableSecond) {
    var date = new Date(epochTime * 1000);
    var day = date.getDate();
    var month = date.getMonth() + 1;
    var hours = date.getHours()
    var minutes = date.getMinutes();
    var second = date.getSeconds();

    if (day < 10) day = '0' + day;
    if (month < 10) month = '0' + month;
    if (hours < 10) hours = '0' + hours;
    if (minutes < 10) minutes = '0' + minutes;
    if (second < 10) second = '0' + second;
    var time = hours + ":" + minutes;
    if (!disableSecond) {
        time = time + ":" + second;
    }
    var dateFormatted = day + '/' + month + '/' + date.getFullYear() + " " + time;

    return dateFormatted;
}

export function formatDateToDDMMYYYY(date) {
    var date = new Date(date);
    var day = date.getDate();
    var month = date.getMonth() + 1;
    if (day < 10) day = '0' + day;
    if (month < 10) month = '0' + month;
    var dateFormatted = day + '/' + month + '/' + date.getFullYear();
    return dateFormatted;
}

export function epochToDDMMYYYYHHSS(epochTime, withDate, withSecond) {
    var d = new Date(epochTime * 1000); // The 0 there is the key, which sets the date to the epoch
    return dateToDDMMYYYYHHmmSS(d, withDate, withSecond);
}

export function dateToDDMMYYYYHHmmSS(date, withTime, withSecond) {
    var date = new Date(date);
    var day = date.getDate();
    var month = date.getMonth() + 1;
    if (day < 10) day = '0' + day;
    if (month < 10) month = '0' + month;
    var dateFormatted = day + '/' + month + '/' + date.getFullYear();

    var hours = date.getHours()
    var minutes = date.getMinutes();
    var second = date.getSeconds();
    if (hours < 10) hours = '0' + hours;
    if (minutes < 10) minutes = '0' + minutes;
    if (second < 10) second = '0' + second;
    var time = hours + ":" + minutes
    if (withSecond)
        time = time + ":" + second;

    return withTime ? (dateFormatted + " " + time) : dateFormatted;
}

export function formatDateToDDMMYYYYHHSSFrEpoch(epochTime, withDate) {
    var d = new Date(epochTime * 1000); // The 0 there is the key, which sets the date to the epoch
    return formatDateTimeToMonthNameAndDayOfWeek(d, withDate);
}

export function formatDateToShortMonthName(date) {
    var date = new Date(date);
    var day = date.getDate();
    var month = date.getMonth();
    if (day < 10) day = '0' + day;
    var months = createShortMonth();
    month = months[month];
    var dateFormatted = day + ' ' + month + ' ' + date.getFullYear();
    return dateFormatted;
}

export function formatDateTimeToMonthNameAndDayOfWeek(date, withDate) {
    var date = new Date(date);
    var dayOfWeeks = createShortDayOfWeek();
    var dayOfWeek = dayOfWeeks[date.getDay()];
    if (withDate) return dayOfWeek + '. ' + formatDateTimeToShortMonthName(date);
    else return formatDateTimeToShortMonthName(date);
}

export function formatDateTimeToShortMonthName(date, withSecond) {
    var date = new Date(date);
    var day = date.getDate();
    var month = date.getMonth();
    if (day < 10) day = '0' + day;
    var months = createShortMonth();
    month = months[month];
    var hours = date.getHours()
    var minutes = date.getMinutes();
    var second = date.getSeconds();
    if (hours < 10) hours = '0' + hours;
    if (minutes < 10) minutes = '0' + minutes;
    if (second < 10) second = '0' + second;
    var time = hours + ":" + minutes
    if (withSecond)
        time = time + ":" + second;
    var dateFormatted = day + ' ' + month + ' ' + date.getFullYear() + " " + time;
    return dateFormatted;
}

export function formatDateToDDMMYYYYHHMMFrEpoch(epochTime, withSecond) {
    var d = new Date(epochTime * 1000); // The 0 there is the key, which sets the date to the epoch
    return formatDateTimeToShortMonthName(d, withSecond);
}

export function formatDateToMonthNameAndDayOfWeek(date) {
    var date = new Date(date);
    var dayOfWeeks = createShortDayOfWeek();
    var dayOfWeek = dayOfWeeks[date.getDay()];

    return dayOfWeek + '. ' + formatDateToShortMonthName(date);
}

export function createShortDayOfWeek() {
    var day = i18next.t('SHORTDAYS', { returnObjects: true });
    let days = [
        day.SUNDAY,
        day.MONDAY,
        day.TUESDAY,
        day.WEDNESDAY,
        day.THURSDAY,
        day.FRIDAY,
        day.SATURDAY,
    ];
    return days;
}

export function createShortMonth() {
    var month = i18next.t('SHORTMONTH', { returnObjects: true });
    let months = [
        month.JAN,
        month.FEB,
        month.MAR,
        month.APR,
        month.MAY,
        month.JUN,
        month.JUL,
        month.AUG,
        month.SEP,
        month.OCT,
        month.NOV,
        month.DEC,
    ];

    return months;
}

export function createFullMonth() {
    var month = i18next.t('MONTH', { returnObjects: true });
    let months = [
        month.JAN,
        month.FEB,
        month.MAR,
        month.APR,
        month.MAY,
        month.JUN,
        month.JUL,
        month.AUG,
        month.SEP,
        month.OCT,
        month.NOV,
        month.DEC,
    ];

    return months;
}

export function createDayOfWeek() {
    let day = i18next.t('DAYS', { returnObjects: true })
    let days = [
        day.SUNDAY,
        day.MONDAY,
        day.TUESDAY,
        day.WEDNESDAY,
        day.THURSDAY,
        day.FRIDAY,
        day.SATURDAY,
    ];
    return days;
}

export function newGUID() {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }
    //return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
    //  s4() + '-' + s4() + s4() + s4();
    return s4() + s4() + s4() + s4() +
        s4() + s4() + s4() + s4();
}

export function formatFloat(value) {
    if (!value)
        return '';
    if (value == '')
        return;
    let val = value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    return val;
}

export function parseFloat(value) {
    if (!value)
        return '';
    if (value == '')
        return;
    let val = value.toString().replace(/,/g, '');
    //val = val.toString().match(/\d*\.?\d{0,2}/);
    val = val.toString().match(/\d*\.?\d*/);
    //val = numeral(val[0]).format('0.00');
    val = val[0];
    //console.log('Parse Float: ' + value + ' to ' + val);
    return val;
}

export function parseAPIFloat(value) {
    if (!value)
        return '';
    if (value == '')
        return;
    let val = value.toString().replace(/,/g, '');
    val = val.toString().match(/\d*\.?\d{0,2}/);
    val = numeral(val[0]).format('0.00');
    // console.log('Parse Float for API: ' + value + ' to ' + val);
    return val;
}

export function formatAmount(value, currency) {
    let strValue = '';
    if (!currency) {
        currency = cache.getCurrency();
    }
    if (value < 0) {
        strValue = '-' + currency + Math.abs(value).toFixed(2)
    } else {
        strValue = currency + value.toFixed(2)
    }
    return strValue;
}

export function mappingValue(value) {
    let translateValue = "";
    if (value) {
        if (value == 'DELIVERY') {
            translateValue = 'delivery'
        } else if (value == 'PICK_UP') {
            translateValue = 'pickup'
        } else if (value == 'DIRECT_SALE') {
            translateValue = 'order_direct_sale'
        } else if (value == 'NOT_EFFECTIVE') {
            translateValue = 'not_effective'
        } else if (value == 'EFFECTIVE') {
            translateValue = 'effective'
        } else if (value == 'PAUSED') {
            translateValue = 'paused'
        } else if (value == 'DRAFT') {
            translateValue = 'draft'
        } else if (value == 'CANCELLED') {
            translateValue = 'cancelled'
        } else if (value == 'REMOVED') {
            translateValue = 'removed'
        } else if (value == 'PENDING_VERIFICATION') {
            translateValue = 'pending_verification'
        } else if (value == 'MONTH') {
            translateValue = 'month_title'
        } else if (value == 'YEAR') {
            translateValue = 'year_title'
        } else if (value == 'day') {
            translateValue = 'day_title'
        } else if (value == "TOP_UP") {
            translateValue = 'financial_event_top_up';
        } else if (value == 'TRANSFER') {
            translateValue = 'financial_event_transfer';
        } else if (value == 'INSTANT') {
            translateValue = 'spend_method_instant';
        } else if (value == 'AUTOMATIC_SPEND' || value === 'AUTO_SPEND') {
            translateValue = 'spend_method_automatic';
        } else if (value == 'ON_REQUEST') {
            translateValue = 'spend_method_on_request';
        } else if (value == 'WALLET_FEE') {
            translateValue = 'wallet_fee';
        } else if (value == 'AWARD') {
            translateValue = 'award';
        } else if (value == 'SPEND') {
            translateValue = 'spend';
        } else if (value == 'CREDIT') {
            translateValue = 'credit';
        } else if (value == 'DEBIT') {
            translateValue = 'debit';
        } else if (value == 'PASS_REDEMPTION') {
            translateValue = 'financial_event_pass'
        } else if (value == 'PURCHASE_CANCELLATION') {
            translateValue = 'financial_event_purchase_cancel'
        } else if (value == 'WALLET_BALANCE_EXPIRATION') {
            translateValue = 'expired_wallet_balance'
        } else if (value == 'POSTED') {
            translateValue = 'posted'
        } else if (value == 'NEW') {
            translateValue = 'new'
        } else if (value == 'COMPLETED') {
            translateValue = 'completed'
        } else if (value == 'PENDING') {
            translateValue = 'pending'
        } else if (value == 'ORDER') {
            translateValue = 'order'
        } else if (value == 'PAYMENT') {
            translateValue = 'payment'
        } else if (value == 'INVOICE') {
            translateValue = 'invoice'
        } else if (value == 'IN_PROGRESS') {
            translateValue = 'in_progress'
        } else {
            translateValue = value
        }
    }
    return translateValue;
}

export function toDateMMDDYYYY({ year, month, day }) {
    if (day < 10) day = '0' + day;
    if (month < 10) month = '0' + month;
    var dateFormatted = month + "/" + day + '/' + year;
    return dateFormatted;
}

export function toDateYYYYMMDD({ year, month, day }) {
    if (day < 10) day = '0' + day;
    if (month < 10) month = '0' + month;
    var dateFormatted = year + '-' + month + "-" + day;
    return dateFormatted;
}

export function validPhoneNumber(number) {
    var re = /^([0-9])+$/;
    if (re.test(number))

        return true;
    else
        return false;
}

export function isValidEmail(email) {
    var re = /^([a-zA-Z0-9_+\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if (re.test(email))
        return true;
    else
        return false;
}

export function getFirstLetter(string) {
    if (string) {
        let newStr = ""
        let splits = string.split(" ");
        if (splits && splits.length > 0) {
            splits.forEach(element => {
                newStr = newStr + element.charAt(0);
            });
        } else {
            newStr = string.charAt(0);
        }
        return newStr;
    }
    return ""
}

export function newGUIDV2() {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
        s4() + '-' + s4() + s4() + s4();
}

export const formatPeriodDate = (date) => {
    return Math.floor(date.getTime() / 1000.0);
}

export function convertEpochTime(date) {
    var date = Math.floor(new Date(date).getTime() / 1000);
    return date;
}

export const daysOfMonth = [
    { label: "1st", value: 1 },
    { label: "2nd", value: 2 },
    { label: "3rd", value: 3 },
    { label: "4th", value: 4 },
    { label: "5th", value: 5 },
    { label: "6th", value: 6 },
    { label: "7th", value: 7 },
    { label: "8th", value: 8 },
    { label: "9th", value: 9 },
    { label: "10th", value: 10 },
    { label: "11th", value: 11 },
    { label: "12th", value: 12 },
    { label: "13th", value: 13 },
    { label: "14th", value: 14 },
    { label: "15th", value: 15 },
    { label: "16th", value: 16 },
    { label: "17th", value: 17 },
    { label: "18th", value: 18 },
    { label: "19th", value: 19 },
    { label: "20th", value: 20 },
    { label: "21st", value: 21 },
    { label: "22nd", value: 22 },
    { label: "23rd", value: 23 },
    { label: "24th", value: 24 },
    { label: "25th", value: 25 },
    { label: "26th", value: 26 },
    { label: "27th", value: 27 },
    { label: "28th", value: 28 },
    { label: "Last day", value: 'LAST_DAY' },
]

export function calculateDistanceTimeFrEpoch(epochTime) {
    var createdDate = new Date(epochTime * 1000)
    var delta = Math.abs(Date.now() - createdDate) / 1000;
    var week = Math.floor(delta / (86400 * 7));
    var days = Math.floor(delta / 86400);
    var hours = Math.floor(delta / 3600) % 24;
    var minutes = Math.floor(delta / 60) % 60;

    if (week > 1) {
        return formatDateToMonthName(createdDate);
    } else if (week == 1) {
        return '1 week ago';
    } else if (days > 0) {
        if (days == 1)
            return '1 day ago';
        return days + ' days ago';
    } else if (hours > 0) {
        if (hours == 1)
            return '1 hour ago';
        return hours + ' hours ago ';
    } else {
        if (minutes == 1)
            return '1 minute ago'
        return minutes + ' minutes ago';
    }
}

export function formatDateToMonthName(date) {
    var date = new Date(date);
    var day = date.getDate();
    var month = date.getMonth();
    if (day < 10) day = '0' + day;
    var months = createFullMonth();
    month = months[month];
    var dateFormatted = day + ' ' + month + ' ' + date.getFullYear();
    return dateFormatted;
}

export function formatDateTimeType2(epochTime, disableSecond) {
    var date = new Date(epochTime * 1000);
    var day = date.getDate();
    var month = date.getMonth() + 1;
    var hours = date.getHours()
    var minutes = date.getMinutes();
    var second = date.getSeconds();

    if (day < 10) day = '0' + day;
    if (month < 10) month = '0' + month;
    if (hours < 10) hours = '0' + hours;
    if (minutes < 10) minutes = '0' + minutes;
    if (second < 10) second = '0' + second;
    var time = hours + ":" + minutes;
    if (!disableSecond) {
        time = time + ":" + second;
    }
    var dateFormatted = date.getFullYear() + "-" + month + "-" + day + "T" + hours + ":" + minutes;

    return dateFormatted;
}

export function replaceParamTranslation(string, params) {
    let str = string;
    if (!str) {
        return string;
    }
    if (params && params.length > 0) {
        for (let i = 0; i < params.length; i++) {
            let value = params[i];
            str = str.replace(`{${i}}`, value);
        }
    }
    return str;
}

export function getCustomFieldByKey(customFields, key) {
    let value = null;
    if (customFields) {
        let filterCustomFields = customFields.filter(c => {
            return c.key == key;
        })
        if (filterCustomFields && filterCustomFields.length > 0) {
            value = filterCustomFields[0].value
        }
    }
    return value;
}

export function createCustomFieldObj(customFields, key, newValue) {
    if(!newValue)
        return;
        
    let newCustomFields = customFields.filter(c => {
        return c.key != key;
    })
    newCustomFields.push({
        key: key,
        value: newValue
    })

    return newCustomFields;
}

export const sleep = (delay) => new Promise((resolve) => setTimeout(resolve, delay))

export const emptyStringIfNull = (str) => {
    return str ? (', ' + str) : '';
}

export const calculateUnixTimestamp = (year, month, day, hour, minute, second) => {
    const totalSeconds =
      second +
      minute * 60 +
      hour * 3600 +
      (day - 1) * 86400 +
      getDaysInYearsSinceEpoch(year - 1970) +
      getDaysInMonthsSinceStart(month, year) -
      1;
    return totalSeconds;
  };

  const getDaysInYearsSinceEpoch = (years) => {
    let days = 0;
    for (let i = 0; i < years; i++) {
      days += isLeapYear(1970 + i) ? 366 : 365;
    }
    return days * 86400;
  };

  const getDaysInMonthsSinceStart = (month, year) => {
    const daysInMonths = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    let days = 0;
    for (let i = 0; i < month - 1; i++) {
      days += daysInMonths[i];
    }
    if (month > 2 && isLeapYear(year)) {
      days++;
    }
    return days * 86400;
  };

  const isLeapYear = (year) => {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
  };